import { formatQuery } from '../../../utils/searchQuery';
import { formatDateQuery } from './format-date-query';

export const handleSearch = ({
  activity,
  location,
  datetime,
  filterQuery,
  currentLocale
}) => {
  const urlPrefix = currentLocale?.url_prefix
    ? `/${currentLocale.url_prefix}`
    : '';

  const searchQuery = formatQuery({
    a: activity.value.id,
    ...location.query
  });

  const dateQuery = datetime
    ? formatDateQuery(datetime.startDate, datetime.endDate, location)
    : '';
  window.location.href = `${urlPrefix}/s/?${searchQuery.toLowerCase()}${dateQuery}${filterQuery}`;
};
